export default __webpack_public_path__ + "static/media/backup.294e01ca.jpeg";